import { render, staticRenderFns } from "./JourneysEdit.vue?vue&type=template&id=8c6beb22&"
import script from "./JourneysEdit.vue?vue&type=script&lang=js&"
export * from "./JourneysEdit.vue?vue&type=script&lang=js&"
import style0 from "./JourneysEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports